import { type FC } from 'react';
import { Landing } from '@/components/Landing/Landing';
import { usePublicEventsStatus } from '@/hooks/usePublicEventsStatus';

/**
 * Home - the public front door at "/". Signed-in people never see it: the route sends them to /home (the dashboard).
 */
export const Home: FC = () => {
  const publicEvents = usePublicEventsStatus() === true;
  return <Landing publicEvents={publicEvents} />;
};
